import { useMutation, useQueryClient } from "@tanstack/react-query";
import React, { useEffect, useState } from "react";
import { toast } from "sonner";

import * as api from "@/api/system_settings";
import { Card, CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { toastError } from "@/lib/api-errors";

export function PalletPhotoCard({ current }: { current: boolean }): React.ReactElement {
  const qc = useQueryClient();
  const [required, setRequired] = useState(current);
  useEffect(() => setRequired(current), [current]);

  const saveMut = useMutation({
    mutationFn: (v: boolean) => api.updateSystemSettings({ pallet_photo_required: v }),
    onSuccess: () => {
      qc.invalidateQueries({ queryKey: ["system-settings"] });
      toast.success("Сохранено");
    },
    onError: toastError("Ошибка сохранения"),
  });

  return (
    <Card>
      <CardHeader>
        <CardTitle className="text-lg">Проверка заказов — фотофиксация паллет</CardTitle>
      </CardHeader>
      <CardContent>
        <label className="flex items-center gap-2 text-sm">
          <input
            type="checkbox"
            checked={required}
            onChange={(e) => {
              setRequired(e.target.checked);
              saveMut.mutate(e.target.checked);
            }}
            disabled={saveMut.isPending}
            className="size-4"
          />
          Обязательная фотофиксация паллеты перед созданием следующей (фото
          прикрепляется к заказу покупателя). Выкл — можно пропустить.
        </label>
      </CardContent>
    </Card>
  );
}
